module.exports = __webpack_public_path__ + "static/media/Weekly_CMI.v1.0 -2018-11-28.a9e7e7d7.pdf";